// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cd3e","img":"styles_img__2nx2v","text":"styles_text__1EThI","btn":"styles_btn__1NyU-","wisecart":"styles_wisecart__nLmzH"};